import type { User } from "@/types/api";
import { userIdentityColors } from "@/lib/identity";

interface UserIdentityAvatarProps {
  user?: Partial<
    Pick<
      User,
      "display_name" | "full_name" | "email" | "identity_color" | "identity_text_color"
    >
  > | null;
  sizeClassName?: string;
  textClassName?: string;
}

export function UserIdentityAvatar({
  user,
  sizeClassName = "w-8 h-8",
  textClassName = "text-xs font-bold",
}: UserIdentityAvatarProps) {
  const displayName =
    user?.display_name ?? user?.full_name ?? user?.email?.split("@")[0] ?? "U";
  const initial = displayName.charAt(0).toUpperCase();

  return (
    <div
      className={`${sizeClassName} rounded-full flex items-center justify-center shrink-0 ${textClassName}`}
      style={userIdentityColors(user)}
      aria-label={displayName}
      title={displayName}
    >
      {initial}
    </div>
  );
}
